"use client";

import { createContext, useContext } from "react";

import type { LpvLayoutConfig } from "@/lib/api/lpv/schema";

const LpvConfigContext = createContext<LpvLayoutConfig | null>(null);

export function LpvConfigProvider({
  config,
  children,
}: {
  config: LpvLayoutConfig;
  children: React.ReactNode;
}) {
  return (
    <LpvConfigContext.Provider value={config}>
      {children}
    </LpvConfigContext.Provider>
  );
}

export function useLpvConfig(): LpvLayoutConfig {
  const config = useContext(LpvConfigContext);
  if (!config) {
    throw new Error("useLpvConfig must be used within a LpvConfigProvider");
  }
  return config;
}
